import { render } from "./LogoComponent.vue?vue&type=template&id=c9881e9e&scoped=true"
import script from "./LogoComponent.vue?vue&type=script&lang=js"
export * from "./LogoComponent.vue?vue&type=script&lang=js"

import "./LogoComponent.vue?vue&type=style&index=0&id=c9881e9e&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9881e9e"]])

export default __exports__